<header class="topbar">
    <button
        type="button"
        class="topbar__toggle"
        [attr.aria-label]="(menuOpen ? 'menu.shell.closeMenu' : 'menu.shell.openMenu') | translate"
        [attr.aria-expanded]="menuOpen"
        (click)="menuToggle.emit()">
        <span class="material-symbols-outlined" aria-hidden="true">{{ menuOpen ? 'close' : 'menu' }}</span>
    </button>
    <a routerLink="/" class="topbar__brand">
        <img class="topbar__logo" [src]="logo" alt="" />
        <span class="sr-only">{{ 'common.title' | translate }}</span>
    </a>
</header>
